import { Box, Grid,  Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import '../styles/Section6.scss';
import { Fade } from "react-awesome-reveal";
import sectionConstants from '../../constants/SectionConstants';
 
const Section6 = () => {
  const data = [
    {
      icon: 'tabler:location-pin',
      name: 'Vehicle Tracking',
      content:
        'Our GPS-based vehicle tracking solutions empower fleet managers and businesses to monitor the precise location, speed, and status of their vehicles in real-time. With our intuitive dashboard, effortlessly track and manage your fleet, enhancing operational efficiency and elevating customer service standards'
    },
    {
      icon: 'mdi:world',
      name: 'Geo-fence',
      content:
        'Seamlessly create virtual boundaries with our geofencing feature and receive instant alerts whenever a vehicle enters or exits specified areas. This powerful tool enhances security measures, prevents unauthorized use, and optimizes operational efficiency, ensuring your fleet always remains secure and productive'
    },
    {
      icon: 'solar:route-linear',
      name: 'Route Optimization',
      content:
        'Route optimization is a critical component of our fleet management system. By leveraging advanced algorithms, our system suggests the most efficient routes for vehicles based on factors such as distance and delivery schedules and maximizes efficiency, reduces fuel consumption, and minimizes delivery times, ultimately driving cost savings and enhancing customer satisfaction'
    },
    {
      icon: 'healthicons:truck-driver',
      name: 'Driver Performance Monitering',
      content:
        'Our fleet management system offers robust driver behavior management features, providing detailed insights into various driving metrics including speeding, idle time, and incidents of harsh braking. By monitoring driver performance, fleet managers can promote safe driving practices, mitigate risks, and improve overall fleet safety'
    },
    {
      icon: 'mdi:monitor-dashboard',
      name: 'Dashboard',
      content:
        'Our dashboard serves as a centralized interface providing key insights and information about various aspects of your fleet`s operations. It integrates data from various sources including vehicles, drivers, routes, maintenance records, fuel consumption, and more, and this will help in making informed decisions and take proactive measures to optimize fleet performance'
    },
    {
      icon: 'tabler:report',
      name: 'Historical Playback ',
      content:
        'Dive into past routes and driving patterns with our historical playback feature. Access and analyze previous tracking data to identify areas for improvement, track trends over time, and make data-driven decisions to optimize overall fleet performance'
    },
    {
      icon: 'material-symbols:notifications-active-outline',
      name: 'Alerts & Notifications',
      content:
        'Stay ahead of critical events with our customizable alerts and notifications. Receive real-time updates on unauthorized vehicle use, excessive speed, and maintenance reminders, enabling proactive measures to ensure safety and security'
    },
    {
      icon: 'tabler:report-analytics',
      name: 'Reports & Analytics',
      content:
        'Gain valuable insights into your fleet operations with our comprehensive reporting and analytics capabilities. Analyze driving behavior, fuel consumption, and usage patterns to identify trends, pinpoint areas for improvement, and make data-driven decisions that drive success'
    },
    {
      icon: 'iconamoon:apps-fill',
      name: 'Mobile Application',
      content:
        'Stay connected and track your fleet on the go with our user-friendly mobile application. Access our full range of tracking features from your smartphone or tablet, ensuring flexibility and convenience wherever you are'
    }
  ];
  return (
    <Box className='glimpse-container'>
      <Fade>
      <Typography paragraph className='heading'>
       {sectionConstants.HereisGlimpse}
      </Typography>
      </Fade>
      <Grid container spacing={3} className='glimpse-component'>
        {data?.map((item, index) => (
          <Grid item xs={12} md={4}lg={4} sm={12}>
            <Box className='glimpse-card'>
              <Icon icon={item.icon} className='glimpse-icon' />
              <Typography paragraph className='glimpse-content'>
                {item.name}
              </Typography>
              <Typography paragraph className={`hover-content img-${index + 1}`}>
                {item.content}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
 
export default Section6;